import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import * as PIXI from "pixi.js";

import { AbstractGameMode } from "../flow/AbstractGameMode";

export class AbstractView extends PIXI.Container implements StageLayer {
    public isDisabled: boolean = false;

    constructor(name: string = `AbstractView`) {
        super();

        this.name = name;

        this.init();
    }

    protected _gameMode: AbstractGameMode;

    public get gameMode(): AbstractGameMode {
        return this._gameMode;
    }

    public set gameMode(value: AbstractGameMode) {
        if (this._gameMode === value) return;

        this._gameMode = value;

        this.onGameModeUpdate();
    }

    protected init(): void {
        this.initGraphics();
    }

    protected initGraphics(): void {}

    protected onGameModeUpdate(): void {}

    public onResize() {}

    public reset() {}
}
